export default {
    common: {
        area: '/uc/support/country'
    },
    uc: { //会员中心接口
        newlogin: '/uc/v2/pre/login',
        v2ogin: '/uc/v2/login',
        login: '/uc/login',
        register: '/uc/register',
        wallet: '/uc/asset/wallet/',
        captcha: '/uc/start/captcha',
        identification: '/uc/approve/certified/business/status', //商家认证
        apply: '/uc/approve/certified/business/apply', //商家认证申请
        announcement: '/uc/announcement/page', //公告列表
        paydividends: "/uc/bonus/user/page", //持币分红
        mylistrecord: "/uc/mine/detail/", //交易挖矿详情
        activitylist: "/uc/activity/page-query", // 活动列表
        memberactivity: "/uc/activity/getmemberrecords", // 用户参与活动列表
        attendActivity: "/uc/activity/attend", // 参与活动
        mypromotion: "/uc/promotion/mypromotion", // 我的推广佣金
        toppromotion: "/uc/promotion/toprank", // 推广合伙人排行
        getfreecard: "/uc/promotion/promotioncard/getfreecard", // 获取免费推广卡
        exchangecard: "/uc/promotion/promotioncard/exchangecard", // 兑换推广卡
        mycardlist: "/uc/promotion/promotioncard/mycard", // 兑换推广卡
        toppromotionmonth: "/uc/promotion/monthtoprank", // 推广合伙人排行
        toppromotionweek: "/uc/promotion/weektoprank", // 推广合伙人排行
        memberInfo: "/uc/member/my-info", // 获取用户信息
        mypromotionrecord: "/uc/promotion/record", //获取推广邀请人记录
        myInnovationOrderList: "/uc/activity/getmyorders", // 创新实验区参与订单列表
        myInnovationMinings: "/uc/miningorder/my-minings", // 获取我的矿机列表
        myInnovationLocked: "/uc/lockedorder/my-locked" // 获取我的矿机列表
    },
    market: { //币币交易行情接口
        ws: '/follow/market-ws',
        thumb: '/spot-api/market/symbol-thumb',
        platemini: '/spot-api/market/exchange-plate-full', //获取10条数据
        trade: '/spot-api/market/latest-trade', //主动查询的实时成交信息
        symbolInfo: '/spot-api/coin/symbol-info-power',
        // coinInfo: '/follow/coin-info',
    },
    swap: {
        ws: '/swap-market/swap-market-ws',
        thumb: '/swap-api/market/tickers',
        // plate: '/swap-market/exchange-plate', //主动查询的盘口信息
        platemini: '/swap-api/market/books', //获取10条数据
        trade: '/swap-api/market/trades', //主动查询的实时成交信息
        symbolInfo: '/swap-api/coin/scale', // 交易对信息
        coinInfo: '/swap/coin/coin-info', // 合约交易对信息
        contractWallet: '/swap-api/wallet/detail', // 用户合约钱包账户信息
        modifyLeverage: '/swap-api/order/modify-leverage', // 修改杠杆
        switchPattern: '/swap/order/switch-pattern', // 修改仓位模式
        cancel: '/swap-api/order/cancel', // 撤销
        getOrder: '/swap-api/order/current', // 当前委托
        getHistory: '/swap-api/order/history' // 历史委托
    },
    option: {
        ws: '/option/option-ws',
        thumb: '/option/symbol-thumb',
    },
    exchange: { //币币交易委托提交与查询接口
        // orderAdd: '/exchange/order/add', //提交订单接口
        current: '/spot-api/order/current', //当前委托接口
        history: '/spot-api/order/history', //历史委托接口
        // favorFind: '/exchange/favor/find', //查询自选
        favorAdd: '/spot-api/exchange/coin/collect/add', //添加自选
        favorDelete: '/spot-api/exchange/coin/collect/add', //删除自选
        orderCancel: '/spot-api/order/cancel' //取消委托
    },
    otc: {
        coin: '/otc/coin/all', //查询支持的币种
        advertise: '/otc/advertise/page-by-unit', //获取广告
        createAd: '/uc/ad/create', //创建广告
        adDetail: '/otc/advertise/detail'
    },
    activity: {
        activity: "/activity/page-query"
    }
}



// WEBPACK FOOTER //
// ./src/config/api.js